import { useEffect, useState } from 'preact/hooks';
import { ceremonyStart } from '../content/wedding';

const TARGET = new Date(ceremonyStart).getTime();
const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

function remaining(now: number) {
  const ms = Math.max(0, TARGET - now);
  return {
    done: ms === 0,
    days: Math.floor(ms / DAY),
    hours: Math.floor((ms % DAY) / HOUR),
    minutes: Math.floor((ms % HOUR) / MIN),
    seconds: Math.floor((ms % MIN) / 1000),
  };
}

const pad = (n: number) => String(n).padStart(2, '0');

export function Countdown() {
  const [t, setT] = useState(() => remaining(Date.now()));

  useEffect(() => {
    if (t.done) return;
    const id = setInterval(() => setT(remaining(Date.now())), 1000);
    return () => clearInterval(id);
  }, [t.done]);

  if (t.done) {
    return (
      <div class="countdown">
        <p class="countdown__done">Today. At last.</p>
      </div>
    );
  }

  const cells: Array<[string, string]> = [
    [String(t.days), t.days === 1 ? 'Day' : 'Days'],
    [pad(t.hours), 'Hours'],
    [pad(t.minutes), 'Minutes'],
    [pad(t.seconds), 'Seconds'],
  ];

  return (
    <div class="countdown">
      {cells.map(([value, label]) => (
        <div class="countdown__cell" key={label}>
          <span class="countdown__n">{value}</span>
          <span class="countdown__l">{label}</span>
        </div>
      ))}
      <span class="visually-hidden">
        {t.days} days until the ceremony.
      </span>
    </div>
  );
}
